import { render } from "./VehicleBack.vue?vue&type=template&id=52e6f3b2"
import script from "./VehicleBack.vue?vue&type=script&lang=js"
export * from "./VehicleBack.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__